// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex-module__flex___2K7w_","primary":"Flex-module__primary___1TUkj"};